import GoogleTagManagerService from './service';
import { trackBlockClick, trackBlockImpression, trackEvent } from "./helpers";

GoogleTagManagerService.registerInstance('[data-tracking-block-impression]', (elements) => {
  const blockImpressionsList = [];

  elements.forEach((element) => {
    if (element.dataset.impressionTracked) return;

    const data = JSON.parse(element.dataset.trackingBlockImpression);

    const bucketName = element.closest('[data-bucket-name]')?.dataset.bucketName;
    const blockType = element.closest('[data-block-type]')?.dataset.blockType;

    let blockImpressionsIndex = blockImpressionsList.findIndex(bi => bi.bucketName === bucketName && bi.blockType === blockType);
    if (blockImpressionsIndex < 0 && blockImpressionsList.length == 0) {
      blockImpressionsIndex = 0;
      blockImpressionsList.push({
        bucketName,
        blockType,
        impressions: [],
      });
    }

    if (blockImpressionsIndex < 0 && blockImpressionsList.length != 0) {
      blockImpressionsIndex = blockImpressionsList.length;
      blockImpressionsList.push({
        bucketName,
        blockType,
        impressions: [],
      });
    }

    blockImpressionsList[blockImpressionsIndex].impressions.push({
      ...data,
    });
    element.dataset.impressionTracked = true;
  });

  if (!blockImpressionsList.length) return;

  blockImpressionsList.forEach(({ bucketName, blockType, impressions }) => impressions.length && trackBlockImpression(bucketName, blockType, impressions));
});

GoogleTagManagerService.registerInstance('[data-tracking-block-click]', (elements) => {
  elements.forEach((element) => {
    const data = JSON.parse(element.dataset.trackingBlockClick);

    const bucketName = element.closest('[data-bucket-name]')?.dataset.bucketName;
    const blockType = element.closest('[data-block-type]')?.dataset.blockType;
    const layoutName = element.closest('[data-layout-name]')?.dataset.layoutName;
    const blockLayout = element.closest('[data-block-layout]')?.dataset.blockLayout;
    const blockStyle = element.closest('[data-block-style]')?.dataset.blockStyle;

    const impressionBlock = element.closest('[data-tracking-block-impression]');
    const promotion = impressionBlock?.dataset.trackingBlockImpression && JSON.parse(impressionBlock.dataset.trackingBlockImpression);

    element.addEventListener('click', () => {
      trackBlockClick(bucketName, blockType, layoutName, blockLayout, blockStyle, data, promotion);
    });
  });
});

GoogleTagManagerService.registerInstance('[data-tracking-click]', (elements) => {
  elements.forEach((element) => {
    element.addEventListener('click', () => {
      const eventName = element.dataset.clickEventName;
      const data = JSON.parse(element.dataset.trackingClick);
      trackEvent(eventName, data);
    });
  });
});
